var React = require('react');

function ArrowRightCircleComponent (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1C6.262 1 1.55 5.394 1.045 11h10.127L8.879 8.707l1.414-1.414L15 12l-4.707 4.707-1.414-1.414L11.172 13H1.045C1.55 18.607 6.262 23 12 23z","fill":"currentColor"}));
}

ArrowRightCircleComponent.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = ArrowRightCircleComponent;

ArrowRightCircleComponent.default = ArrowRightCircleComponent;
